(function() {
    var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
    window.Tooltip = (function() {
        function Tooltip(ref) {
            this.ref = ref;
            this.hideTooltip = bind(this.hideTooltip, this);
            this.addPositionClass = bind(this.addPositionClass, this);
            this.showTooltip = bind(this.showTooltip, this);
            this.tryToHide = bind(this.tryToHide, this);
            this.setContents = bind(this.setContents, this);
            this.container = this.ref.find('.j-contentsTooltip');
            this.body = $('body');
            this.tooltipBtns = this.body.find('.j-tooltipBtn');
            this.close = this.ref.find('.j-close');
            this.padding = 15;
            this.distanceOfArrow = 25;
            this.max_width = 1280;
            this.classes = ['top', 'bottom', 'right', 'left', 'center'];
            this.w = $(window);
            this.ref.hover((function(_this) {
                return function(e) {
                    return _this.isPossibleToHide = false;
                };
            })(this), (function(_this) {
                return function(e) {
                    return _this.isPossibleToHide = true;
                };
            })(this));
            this.setContents();
        }

        Tooltip.prototype.setContents = function() {
            var _data_content, _data_type, btn, content, i, k, ref, tooltipBtn;
            for (i = k = 0, ref = this.tooltipBtns.length; 0 <= ref ? k < ref : k > ref; i = 0 <= ref ? ++k : --k) {
                tooltipBtn = $(this.tooltipBtns[i]);
                btn = tooltipBtn.find('.j-btn');
                content = tooltipBtn.find('.j-contentTooltip');
                _data_content = tooltipBtn.attr('data-content');
                _data_type = tooltipBtn.attr('data-type');
                content.attr('data-content', "" + _data_content);
                this.container.append(content);
                content.hide();
                if (!Modernizr.touchevents && _data_type === 'hover') {
                    btn.hover((function(_this) {
                        console.log('hover event tooltip.js');
                        return function(e) {
                            _this.close.hide();
                            e.preventDefault();
                            tooltipBtn = $(e.currentTarget);
                            return _this.showTooltip(tooltipBtn);
                        };
                    })(this), (function(_this) {
                        return function(e) {
                            return _this.hideTooltip();
                        };
                    })(this));
                } else {
                    btn.hover((function(_this) {
                        return function(e) {
                            _this.close.show();
                            e.preventDefault();
                            tooltipBtn = $(e.currentTarget);
                            return _this.showTooltip(tooltipBtn);
                        };
                    })(this), (function(_this) {
                        return function(e) {
                            return _this.tryToHide(tooltipBtn);
                        };
                    })(this));
                }
            }
            return this.close.click((function(_this) {
                return function(e) {
                    e.preventDefault();
                    _this.isPossibleToHide = true;
                    return _this.hideTooltip();
                };
            })(this));
        };

        Tooltip.prototype.tryToHide = function(tooltipBtn) {
            var __tm;
            return __tm = setTimeout((function(_this) {
                return function() {
                    clearTimeout(__tm);
                    if (_this.isPossibleToHide) {
                        return _this.hideTooltip(tooltipBtn);
                    } else {
                        return _this.tryToHide(tooltipBtn);
                    }
                };
            })(this), 3000);
        };

        Tooltip.prototype.showTooltip = function(tooltipBtn) {
            var __contentToview, _data_content, _is_vertical, _jbtn, _offset, btn_height, btn_width, diff, newVerticalTop, posLeft, posTop, ref_height, ref_width;
            this.isPossibleToHide = true;
            _jbtn = tooltipBtn.closest('.j-tooltipBtn');
            _data_content = _jbtn.attr('data-content');
            this.ref.show();
            this.ref.find('.j-contentTooltip').hide();
            __contentToview = this.ref.find($("[data-content='" + _data_content + "']"));
            __contentToview.show();
            __contentToview.hover((function(_this) {
                return function(e) {};
            })(this));
            _is_vertical = this.w.width() < window.breakpointer.sm || _jbtn.attr('data-orientation') === 'vertical' ? true : false;
            diff = this.w.width() > this.max_width ? (this.w.width() - this.max_width) / 2 : 0;
            ref_height = this.ref.outerHeight(true);
            ref_width = this.ref.outerWidth(true);
            _offset = tooltipBtn.offset();
            btn_width = tooltipBtn.outerWidth(true);
            btn_height = tooltipBtn.outerHeight(true);
            this.__classes_to_add = [];
            if (_is_vertical) {
                posTop = _offset.top + btn_height + this.padding;
                posLeft = _offset.left - ref_width / 2 + btn_width / 2;
            } else {
                posTop = _offset.top + btn_height / 2 - this.distanceOfArrow;
                posLeft = _offset.left - ref_width - this.padding;
            }
            if (posLeft < 0) {
                posLeft = _is_vertical ? _offset.left : _offset.left + btn_width + this.padding;
                this.__classes_to_add.push('left');
            } else if (posLeft + ref_width > this.w.width() && _is_vertical) {
                posLeft = _offset.left - ref_width + btn_width / 2 + this.distanceOfArrow;
                this.__classes_to_add.push('right');
            } else {
                if (_is_vertical) {
                    this.__classes_to_add.push('center');
                } else {
                    this.__classes_to_add.push('right');
                }
                posLeft = posLeft - diff;
            }
            if (posTop + ref_height > $(window).scrollTop() + $(window).height()) {
                newVerticalTop = posTop - ref_height - btn_height - this.padding * 2;
                posTop = _is_vertical ? newVerticalTop : posTop - ref_height + this.distanceOfArrow * 2;
                this.__classes_to_add.push('bottom');
            } else {
                this.__classes_to_add.push('top');
            }
            this.addPositionClass();
            return this.ref.css({
                "top": posTop + "px",
                "left": posLeft + "px"
            });
        };

        Tooltip.prototype.addPositionClass = function() {
            var i, j, k, l, ref, ref1;
            for (i = k = 0, ref = this.classes.length; 0 <= ref ? k < ref : k > ref; i = 0 <= ref ? ++k : --k) {
                this.ref.removeClass(this.classes[i]);
            }
            for (j = l = 0, ref1 = this.__classes_to_add.length; 0 <= ref1 ? l < ref1 : l > ref1; j = 0 <= ref1 ? ++l : --l) {
                this.ref.addClass(this.__classes_to_add[j]);
            }
            return this.__classes_to_add = [];
        };

        Tooltip.prototype.hideTooltip = function() {
            this.ref.hide();
            return this.ref.find('.j-contentTooltip').hide();
        };

        return Tooltip;

    })();

}).call(this);